import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import { useRezaEligibleList, useRezaSelection } from '@gov-nx/core/hooks';
import type { Nullable } from '@gov-nx/core/types';
import { propEq } from '@gov-nx/core/types';
import type { PageCode } from '../definitions/codes';
import type { ProfileRezaListContextTypes } from './context.types';

const ProfileRezaListContext =
	createContext<Nullable<ProfileRezaListContextTypes>>(null);

export const ProfileRezaListContextProvider = ({
	code,
	children,
}: PropsWithChildren<{ code: PageCode }>) => {
	const { isRezaSelected, activeReza } = useRezaSelection();
	const { data, isLoading, isError } = useRezaEligibleList({
		filter: { typ: 'implicitni' },
		isArchivePage: false,
	});
	const list = data?.seznam ?? [];

	return (
		<ProfileRezaListContext.Provider
			value={{
				code,
				zmocnitelData: !isRezaSelected
					? list.filter(propEq('role', 'zmocnitel'))
					: [],
				zmocnenecData: list
					.filter(propEq('role', 'zmocnenec'))
					.filter((reza) => {
						if (isRezaSelected) {
							return reza.kod === activeReza?.kod;
						}
						return true;
					}),
				isNoItems: list.length === 0,
				isLoading,
				isError,
			}}>
			{children}
		</ProfileRezaListContext.Provider>
	);
};

export const useProfileRezaListContext = (): ProfileRezaListContextTypes =>
	useContext(ProfileRezaListContext) as ProfileRezaListContextTypes;
